import React from 'react';
import DENTModalOverviewSurfaces from '../DENTModalOverviewSurfaces/DENTModalOverviewSurfaces';
import { useToothRestorationSurfaces } from '../../Hooks/Tooth/Restoration/useToothRestorationSurfaces';
import { ToothRestorationType } from '../../../../graphql/graphql';

const DENTToothQuickRestorationModalFillingButtons = () => {
	const { showedSurfaces, selectedSurfaces, handleSelectSurface } =
		useToothRestorationSurfaces(ToothRestorationType.Filling);

	const surfaceHandler = {
		showedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
	};

	return (
		<DENTModalOverviewSurfaces
			onSelectSurface={handleSelectSurface}
			surfaces={surfaceHandler}
		/>
	);
};

export default DENTToothQuickRestorationModalFillingButtons;
